import React from 'react';
import ModalStore from '@app/src/common/store/ModalStore';
import ReloadModal from '@app/src/common/components/modals/reload-modal/ReloadModal';

// Shared across all boundary instances: several boundaries can catch the same
// failed chunk load (e.g. header and content), but the reload modal must
// appear only once per page lifetime.
let reloadModalShown = false;

export default class ErrorBoundary extends React.Component<
  React.PropsWithChildren<{}>
> {
  state = { hasError: false, needReload: false };

  static getDerivedStateFromError(error: any) {
    if (error.name === 'ChunkLoadError') {
      return { hasError: false, needReload: true };
    } else if (
      error.name.includes('SyntaxError') &&
      error.message?.startsWith('Unexpected token')
    ) {
      return { hasError: false, needReload: true };
    }
    return { hasError: true, needReload: false };
  }

  componentDidMount() {
    this.showReloadModalIfNeeded();
  }

  componentDidUpdate() {
    this.showReloadModalIfNeeded();
  }

  private showReloadModalIfNeeded() {
    if (this.state.needReload && !reloadModalShown) {
      reloadModalShown = true;
      ModalStore.showModal(props => <ReloadModal {...props} />).then(() =>
        window.location.reload()
      );
    }
  }

  render() {
    if (this.state.hasError) {
      return <h1>Sorry.. there was an error. Please contact support.</h1>;
    }

    if (this.state.needReload) {
      return <h1>The platform has been updated. Need to reload.</h1>;
    }

    return this.props.children;
  }
}
